import { CurrencyCode, SupportedPricingCurrencyType } from '@buggy/shared'
import { Workspace } from '@/api/user-api'
import { CountryCode } from '@/constants/country-code'
import { SupportedLanguages } from '@/i18n/config'

const getCurrencyCodeFromLanguage = (
  lang?: string,
): SupportedPricingCurrencyType => {
  switch (lang) {
    case SupportedLanguages.zhTW:
      return CurrencyCode.TWD
    case SupportedLanguages.ja:
      return CurrencyCode.JPY
    default:
      return CurrencyCode.USD
  }
}

const getCurrencyCodeFromCountryCode = (
  countryCode?: Workspace['countryCode'],
): SupportedPricingCurrencyType => {
  switch (countryCode) {
    case CountryCode.TW:
      return CurrencyCode.TWD
    case CountryCode.JP:
      return CurrencyCode.JPY
    default:
      return CurrencyCode.USD
  }
}

const mapCurrency = (
  currency?: Workspace['currencyCode'],
): SupportedPricingCurrencyType => {
  switch (currency) {
    case CurrencyCode.TWD:
    case CurrencyCode.JPY:
      return currency
    default:
      return CurrencyCode.USD
  }
}

const mapDollarSign = (currency?: Workspace['currencyCode']): string => {
  if (currency === CurrencyCode.JPY) {
    return '¥'
  }

  return '$'
}

export {
  getCurrencyCodeFromCountryCode,
  getCurrencyCodeFromLanguage,
  mapDollarSign,
}
export default mapCurrency
